import React, { useState, useEffect } from 'react';
import ModernTable, { ModernPageContainer, ModernPageHeader } from '../components/ModernTable';
import BackButton from '../../items/buttons/BackButton';
import LoadingIcon from '../../items/buttons/LoadingIcon';
import Swal from 'sweetalert2';
import request from '../../../services/Request';
import AddReceipt from './AddReceipt';
import { userLimits } from '../uitls/userLimits';
import { Box, Typography, alpha } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import ReceiptIcon from '@mui/icons-material/Receipt';
import AddIcon from '@mui/icons-material/Add';
import ForwardToInboxIcon from '@mui/icons-material/ForwardToInbox';
import FileCopyIcon from '@mui/icons-material/FileCopy';
import { imageOnError } from '../../../services/method/methods';

export default function EmailReceipt(props) {
  const theme = useTheme();
  const { _id, tableTitle, superAdmin, access } = userLimits(
    props.match.params.id,
    props.match.params.group,
    'Email Receipt',
    'edit_receipt'
  );

  const [reflesh, setReflesh] = useState(false);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  const [show, setShow] = useState(false);
  const [update, setupdate] = useState(false);
  const [notnew, setnotnew] = useState(false);
  const [rowdata, setrowdata] = useState('');

  const [pagination, setPagination] = useState(
    localStorage.getItem('table_view_email') ? localStorage.getItem('table_view_email') : 5
  );

  useEffect(() => {
    localStorage.setItem('table_view_email', pagination);
  }, [pagination]);

  useEffect(() => {
    let isCancelled = false;

    async function getER() {
      await request({
        method: 'get',
        url:
          !props.match.params.group && superAdmin ? '/receiptByEmail/' : '/receiptByEmail/' + _id,
      }).then((res) => {
        if (!isCancelled) {
          setData(res.data);
          setLoading(true);
        }
      });
    }
    getER();

    return () => {
      isCancelled = true;
    };
  }, [reflesh]);

  const handleDelete = async (id, newData) => {
    await request({
      method: 'delete',
      url: '/receipt/delete/' + id,
    }).then(() => {
      Swal.fire({
        text: `A receipt template has been deleted: ${newData.name}`,
        icon: 'success',
      }).then(() => {
        reflesh ? setReflesh(false) : setReflesh(true);
      });
    });
  };

  const duplicateReceipt = (rowData) => {
    Swal.fire({
      title: 'Duplicate Receipt Template?',
      text: `Are you sure you want to duplicate "${rowData.name}"?`,
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, duplicate it',
      cancelButtonText: 'Cancel',
    }).then((result) => {
      if (result.isConfirmed) {
        setLoading(false);
        request({
          method: 'post',
          url: '/receipt/duplicate/' + rowData?._id,
        })
          .then(() => {
            Swal.fire('Success', 'Successfully duplicated the receipt', 'success');
            setReflesh(!reflesh);
            setLoading(true);
          })
          .catch(() => {
            Swal.fire('Fail', 'Fail to duplicate the receipt', 'error');
            setReflesh(!reflesh);
            setLoading(true);
          });
      }
    });
  };

  const columns = [
    {
      title: 'Logo Image',
      field: 'logo',
      render: (rowData) =>
        rowData.logo != '' ? (
          <img
            src={`${process.env.REACT_APP_SERVER_API}/pictures/${rowData.logo}/${_id}`}
            style={{ maxWidth: 200, borderRadius: 8 }}
            onError={imageOnError}
          />
        ) : (
          <Typography variant="body2" color="text.secondary">
            No image
          </Typography>
        ),
    },
    {
      title: 'Template Name',
      field: 'name',
      render: (rowData) => (
        <Typography variant="body2" sx={{ fontWeight: 600, color: theme.palette.primary.main }}>
          {rowData.name}
        </Typography>
      ),
    },
  ];
  return (
    <ModernPageContainer>
      {!loading && <LoadingIcon />}

      <ModernPageHeader
        title={tableTitle || 'Email Receipt'}
        subtitle="Manage email receipt templates"
        icon={ReceiptIcon}
        buttonText={access ? 'Add Template' : undefined}
        buttonIcon={AddIcon}
        onButtonClick={
          access
            ? () => {
                setupdate(false);
                setnotnew(false);
                setShow(true);
              }
            : undefined
        }
      />

      <Box sx={{ mt: 3 }}>
        <ModernTable
          onRowsPerPageChange={setPagination}
          columns={columns}
          data={data}
          editable={
            access && {
              onRowDelete: (newData, oldData) =>
                new Promise((resolve, reject) => {
                  setTimeout(() => {
                    handleDelete(newData._id, newData);
                    resolve();
                  }, 1000);
                }),
            }
          }
          actions={[
            () =>
              access && {
                icon: 'edit',
                tooltip: 'Edit/Show Template',
                onClick: (event, rowData) => {
                  setupdate(true);
                  setnotnew(true);
                  setrowdata(rowData);
                  setShow(true);
                },
              },
            () =>
              access && {
                icon: FileCopyIcon,
                tooltip: 'Duplicate the receipt',
                onClick: (event, rowData) => {
                  duplicateReceipt(rowData);
                },
              },
            () =>
              access && {
                icon: ForwardToInboxIcon,
                tooltip: 'Send My Testing Receipt',
                onClick: async (event, rowData) => {
                  const { value: email } = await Swal.fire({
                    title: 'Enter the email address',
                    input: 'email',
                    inputPlaceholder: 'Enter the email address',
                  });
                  if (email) {
                    Swal.fire({
                      title: `Please Wait for response`,
                      didOpen: () => {
                        Swal.showLoading();
                      },
                    });
                    await request({
                      method: 'post',
                      url: '/receipt/send/' + rowData._id,
                      data: {
                        email: email,
                        receipt: rowData._id,
                      },
                    })
                      .then(() => {
                        Swal.fire({
                          icon: 'success',
                          text: `The receipt template has been send to your email.`,
                        });
                      })
                      .catch(() => {
                        Swal.fire({
                          icon: 'error',
                          text: `The receipt template fail to send, Please check your smtp setting.`,
                        });
                      });
                  }
                },
              },
          ]}
          options={{
            actionsColumnIndex: -1,
            pageSize: parseInt(pagination),
            pageSizeOptions: [10, 20, 50, 100],
          }}
        />
        <Box sx={{ mt: 2 }}>
          <BackButton />
        </Box>
      </Box>

      <AddReceipt
        reflesh={reflesh}
        setReflesh={setReflesh}
        data={rowdata}
        update={update}
        notnew={notnew}
        referTo={_id}
        show={show}
        onHide={() => {
          setShow(false);
        }}
      />
    </ModernPageContainer>
  );
}
